//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/scheduledActions/views/main/lan/es';
import deleteScheduledAction from 'Modules/scheduledActions/views/components/deleteScheduledAction/lan/es';
import editScheduledAction from 'Modules/scheduledActions/views/components/editScheduledAction/lan/es';
import scheduledActionsTab from 'Modules/scheduledActions/views/components/tab/lan/es';

locales = {
    ...locales,
    ...main,
    ...deleteScheduledAction,
    ...editScheduledAction,
    ...scheduledActionsTab,
};


export default locales;